import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import ZoomControlButton from '../../../components/ZoomControlButton';
import DetailsAccordion from '../../../components/DetailsAccordion/CTHDetailsAccordion';

import CTHChart from './CTHChart';
import AvgCycleTime from './AvgCycleTime';

import '../CTH.scss';

class WallboardCTHChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p style={{ display: 'flex', gap: '0.2em', alignItems: 'center' }}>
              Cycle Time Histogram
              {this.props.isFatTailed !== undefined && (
                <div style={{ fontSize: '0.8em' }}>
                  <span>({this.props.isFatTailed ? 'Fat-Tailed Distribution' : 'Thin-Tailed Distribution'})</span>
                </div>
              )}
            </p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="cth" showAvgChart options={{ avgChartTooltip: 'Cycle time averages' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.avgChart && (this.props.data.series && !!this.props.data.series.length ? (
            <AvgCycleTime data={this.props.data.series} dateFormat={this.props.dateFormat} />
          ) : (
            <CardPlaceholder title="Cycle time averages" shape="line" loading={this.props.isLoading} />
          ))}
        </div>
        
        <div className="chart_row">
          <div className="diagram_details">
            <ZoomControlButton chart="cth" />
            <CTHChart id="CTH" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
          </div>
          <DetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.cth.avgChart,
    data: state.cth.data,
    isLoading: state.cth.isLoading,
    isFatTailed: state.cth.isFatTailed,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTHChart);
